import { useI18n } from "../i18n/i18n";

export default function Methodology() {
  const { t } = useI18n();
  const steps = t("methodology.steps");

  return (
    <section
      id="methodology"
      data-testid="methodology-section"
      className="relative py-24 md:py-32 border-t border-white/5 bg-gradient-to-b from-transparent via-[#16242f]/60 to-transparent"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <p className="cs-overline mb-4">{t("methodology.overline")}</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              {t("methodology.title")}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-slate-400 text-base lg:text-lg leading-relaxed">
              {t("methodology.subtitle")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-800/60 rounded-2xl overflow-hidden">
          {steps.map((s, i) => (
            <div
              key={i}
              data-testid={`methodology-step-${i}`}
              className="bg-[#243749] p-8 lg:p-10 group transition-colors hover:bg-[#2a3d52]"
            >
              <div className="flex items-baseline gap-4 mb-4">
                <span className="font-display text-5xl text-sky-400/90 leading-none">{s.n}</span>
                <div className="h-px flex-1 bg-slate-800 group-hover:bg-sky-400/40 transition-colors" />
              </div>
              <h3 className="font-display text-xl text-white mb-3">{s.title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
